import {
  GET_BUSINESS,
  GET_BUSINESS_SUCCESS,
  ADD_BUSINESS,
  PATCH_BUSINESS_GOVERNANCE_RIGHTS,
  PATCH_BUSINESS_GOVERNANCE_RIGHTS_SUCCESS,
  PATCH_BUSINESS_AS_ADMIN_ACTION,
  PATCH_USER_ACTIVATION,
  ADMIN_PATCH_BUSINESS_ROLE,
  ADMIN_DELETE_BUSINESS_ROLE,
  GET_APP_SETTINGS,
  GET_APP_SETTINGS_SUCCESS,
} from "./constants"

export function getAllBusinessAction() {
  return {
    type: GET_BUSINESS,
  }
}

export function getAllBusinessActionSuccess(payload) {
  return {
    type: GET_BUSINESS_SUCCESS,
    payload: payload,
  }
}

export function addBusinessAction(payload) {
  return {
    type: ADD_BUSINESS,
    payload: payload,
  }
}

export function patchBusinessGoveranceRightsAction(payload) {
  return {
    type: PATCH_BUSINESS_GOVERNANCE_RIGHTS,
    payload: payload,
  }
}

export function patchBusinessGoveranceRightsSuccess(payload) {
  return {
    type: PATCH_BUSINESS_GOVERNANCE_RIGHTS_SUCCESS,
    payload: payload,
  }
}

export function patchBusinessAsAdminAction(payload) {
  return {
    type: PATCH_BUSINESS_AS_ADMIN_ACTION,
    payload: payload,
  }
}

export function patchUserActivationAction(payload) {
  return {
    type: PATCH_USER_ACTIVATION,
    payload,
  }
}

export function patchBusinessRole(payload) {
  return {
    type: ADMIN_PATCH_BUSINESS_ROLE,
    payload,
  }
}

export function deleteBusinessRole(payload) {
  return {
    type: ADMIN_DELETE_BUSINESS_ROLE,
    payload,
  }
}

export function getAppSettingsAction() {
  return {
    type: GET_APP_SETTINGS,
  }
}

export function getAppSettingsActionSuccess(payload) {
  return {
    type: GET_APP_SETTINGS_SUCCESS,
    payload: payload,
  }
}
